import CareerApplicationReview from '../../../internal/career_applications/career_application_review.js.jsx';

export default CareerApplicationReview;
